import { getToken, getStorage } from '@/utils'

const hasLogin = getStorage('hasLogin')
const refreshToken = getToken('refreshToken')
const token = getToken('token')

const state = {
  refreshToken: refreshToken || '', // 刷新token
  token: token || '', // 用户token
  hasLogin: hasLogin || false // 判断是否登录
}

export default state
